import { render, staticRenderFns } from "./ItemFilterPremiumMyLayout.vue?vue&type=template&id=016614bd&scoped=true"
import script from "./ItemFilterPremiumMyLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterPremiumMyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016614bd",
  null
  
)

export default component.exports